import { nifiReportService } from 'api/nifiReportService';

export const FETCH_NIFI_REPORT_REQUEST = 'FETCH_NIFI_REPORT_REQUEST';
export const FETCH_NIFI_REPORT_SUCCESS = 'FETCH_NIFI_REPORT_SUCCESS';
export const FETCH_NIFI_REPORT_ERROR = 'FETCH_NIFI_REPORT_ERROR';
export const FETCH_NIFI_TRENDS_REQUEST = 'FETCH_NIFI_TRENDS_REQUEST';
export const FETCH_NIFI_TRENDS_SUCCESS = 'FETCH_NIFI_TRENDS_SUCCESS';
export const FETCH_NIFI_TRENDS_ERROR = 'FETCH_NIFI_TRENDS_ERROR';
export const SET_NIFI_REPORT_FILTERS = 'SET_NIFI_REPORT_FILTERS';

interface NifiReportFilters {
  apps: string;
  source?: string;
  startDate?: string;
  endDate?: string;
}

const fetchNifiReportRequest = () => ({
  type: FETCH_NIFI_REPORT_REQUEST
});

const fetchNifiReportSuccess = (data: any) => ({
  type: FETCH_NIFI_REPORT_SUCCESS,
  payload: data
});

const fetchNifiReportError = (error: string) => ({
  type: FETCH_NIFI_REPORT_ERROR,
  payload: error
});

const fetchNifiTrendsRequest = () => ({
  type: FETCH_NIFI_TRENDS_REQUEST
});

const fetchNifiTrendsSuccess = (data: any) => ({
  type: FETCH_NIFI_TRENDS_SUCCESS,
  payload: data
});

const fetchNifiTrendsError = (error: string) => ({
  type: FETCH_NIFI_TRENDS_ERROR,
  payload: error
});

export const setNifiReportFilters = (filters: NifiReportFilters) => ({
  type: SET_NIFI_REPORT_FILTERS,
  payload: filters
});

export const fetchNifiReport = (filters: NifiReportFilters) => {
  return async (dispatch: any) => {
    dispatch(fetchNifiReportRequest());
    try {
      const response = await nifiReportService.fetchNifiReport(filters);
      if (response.ok) {
        const data = await response.json();
        dispatch(fetchNifiReportSuccess(data));
      } else {
        const errorText = await response.text();
        dispatch(fetchNifiReportError(errorText || 'Failed to fetch Nifi report'));
      }
    } catch (error: any) {
      dispatch(fetchNifiReportError(error.message || 'Network error occurred'));
    }
  };
};

export const fetchNifiDailyTrends = (filters: NifiReportFilters) => {
  return async (dispatch: any) => {
    dispatch(fetchNifiTrendsRequest());
    try {
      // The daily trends API will automatically return monthly trends if the date range is > 30 days
      const response = await nifiReportService.fetchNifiDailyTrends(filters);
        
      if (response.ok) {
        const data = await response.json();
        // Extract the trends array from the response
        dispatch(fetchNifiTrendsSuccess(data.trends || []));
      } else {
        const errorText = await response.text();
        dispatch(fetchNifiTrendsError(errorText || 'Failed to fetch Nifi trends'));
      }
    } catch (error: any) {
      dispatch(fetchNifiTrendsError(error.message || 'Network error occurred'));
    }
  };
};
